import React, { useMemo, useState } from "react";
import { Formik, Form, Field } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { Input, ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useFilterObjectsUIContext } from "../../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import { isEqual } from "lodash";
import { Accordion, Card, Button } from "react-bootstrap";
import { otherFields } from "../UsersUtils";

export const UserEditForm = ({
  formFields,
  ObjectEditSchema,
  object,
  btnRef,
  saveObject,
  isFullAccess,
  prepareFilter,
  haveImage = false
}) => {


  const [pic, setPic] = useState("");

  const getUserPic = () => {
    if (!pic) {
      return "none";
    }

    return `url(${pic})`;
  };
  const removePic = () => {
    setPic("");
  };

  const filterUIContext = useFilterObjectsUIContext();
  const objectsUIProps = useMemo(() => {
    return {
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
    };
  }, [filterUIContext]);

  const createFields = (field, setFieldValue, values) => {

    if (field.type === "select") {
      return (

        <Field
          name={field.name}
          component={field.component}
          placeholder={intl.formatMessage({ id: field.placeholder })}
          // label={intl.formatMessage({ id: field.label })}
          type={field.type}
          as={field.as}
          disabled={!isFullAccess}
          onChange={(e) => {
            handleChangeLocal({
              val: e.currentTarget.value,
              field,
              setFieldValue,
              values
            });
          }}
        // value={values[field.name]}
        />

      );
    }
    else {
      return (

        <Field
          name={field.name}
          component={field.component}
          placeholder={intl.formatMessage({ id: field.placeholder })}
          // label={intl.formatMessage({ id: field.label })}
          type={field.type}
          as={field.as}
          disabled={!isFullAccess}
        // value={values[field.name]}
        />

      );
    }

  };

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(objectsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, objectsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      objectsUIProps.setQueryParams(newQueryParams);
    }

  };

  const handleChangeLocal = ({ val, field, setFieldValue, values }) => {
    const temp = { ...object };
    temp[field.name] = val;
    setFieldValue(field.name, +val);
    field.relField.forEach(element => {
      setFieldValue(element, 0);
      temp[element] = 0
    });

    values = {
      ...values,
      ...field.relValues
    }

    values[field.name] = +val

    applyFilter(temp);
    console.log("values")
    console.log(values)
  };

  const intl = useIntl();

  return (
    <>

      <Formik
        enableReinitialize={true}
        initialValues={object}
        validationSchema={ObjectEditSchema}
        onSubmit={(values) => {
          saveObject(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (


          <Form className="form form-label-right">
            <div className="form">
              <div className="card-body">

                {haveImage && <div className="form-group row ">
                  <label className="col-xl-3 col-lg-3 col-form-label"></label>
                  <div className="col-lg-9 col-xl-6">
                    <div
                      className="image-input image-input-outline"
                      id="kt_profile_avatar"
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl(
                          "/media/users/blank.png"
                        )}`,
                      }}
                    >
                      <div
                        className="image-input-wrapper"
                        style={{ backgroundImage: `${getUserPic()}` }}
                      />
                      <label
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="change"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Change avatar"
                      >
                        <i className="fa fa-pen icon-sm text-muted"></i>
                        <input
                          type="file"
                          name="pic"
                          accept=".png, .jpg, .jpeg"
                        // {...formik.getFieldProps("pic")}
                        />
                        <input type="hidden" name="profile_avatar_remove" />
                      </label>
                      <span
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="cancel"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Cancel avatar"
                      >
                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                      </span>
                      <span
                        onClick={removePic}
                        className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                        data-action="remove"
                        data-toggle="tooltip"
                        title=""
                        data-original-title="Remove avatar"
                      >
                        <i className="ki ki-bold-close icon-xs text-muted"></i>
                      </span>
                    </div>
                    <span className="form-text text-muted">
                      png, jpg, jpeg.
                     </span>
                  </div>
                </div>}

                {formFields.map((field) => (
                  <div key={field.rowIdx} className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">
                      {intl.formatMessage({ id: field.label })}
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      {createFields(field, setFieldValue, values)}
                    </div>
                  </div>
                ))}

                {otherFields.map((field) => (
                  <div key={field.rowIdx} className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">
                      {intl.formatMessage({ id: field.label })}
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      {createFields(field, setFieldValue, values)}
                    </div>
                  </div>
                ))}


                {/* <Accordion defaultActiveKey="0">

                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="0">
                        {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.PERSONAL" })}
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="0">
                      <Card.Body>
                      
                        {haveImage && <div className="form-group row">
                          <label className="col-xl-3 col-lg-3 col-form-label"></label>
                          <div className="col-lg-9 col-xl-6">
                            <div
                              className="image-input image-input-outline"
                              id="kt_profile_avatar"
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl(
                                  "/media/users/blank.png"
                                )}`,
                              }}
                            >
                              <div
                                className="image-input-wrapper"
                                style={{ backgroundImage: `${getUserPic()}` }}
                              />
                              <label
                                className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                data-action="change"
                                data-toggle="tooltip"
                                title=""
                                data-original-title="Change avatar"
                              >
                                <i className="fa fa-pen icon-sm text-muted"></i>
                                <input
                                  type="file"
                                  name="pic"
                                  accept=".png, .jpg, .jpeg"
                                // {...formik.getFieldProps("pic")}
                                />
                                <input type="hidden" name="profile_avatar_remove" />
                              </label>
                              <span
                                className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                data-action="cancel"
                                data-toggle="tooltip"
                                title=""
                                data-original-title="Cancel avatar"
                              >
                                <i className="ki ki-bold-close icon-xs text-muted"></i>
                              </span>
                              <span
                                onClick={removePic}
                                className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                data-action="remove"
                                data-toggle="tooltip"
                                title=""
                                data-original-title="Remove avatar"
                              >
                                <i className="ki ki-bold-close icon-xs text-muted"></i>
                              </span>
                            </div>
                            <span className="form-text text-muted">
                              png, jpg, jpeg.
                     </span>
                          </div>
                        </div>}

                        {formFields.filter(q => q.rowIdx <= 8).map((field) => (
                          <div key={field.rowIdx} className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {intl.formatMessage({ id: field.label })}
                            </label>
                            <div className="col-lg-9 col-xl-6">
                              {createFields(field, setFieldValue, values)}
                            </div>
                          </div>
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="1">
                        {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.LOGIN" })}
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                      {formFields.filter(q => q.rowIdx <= 10 && q.rowIdx >= 9).map((field) => (
                          <div key={field.rowIdx} className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {intl.formatMessage({ id: field.label })}
                            </label>
                            <div className="col-lg-9 col-xl-6">
                              {createFields(field, setFieldValue, values)}
                            </div>
                          </div>
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="2">
                        {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.UNI" })}
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        {otherFields.map((field) => (
                          <div key={field.rowIdx} className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {intl.formatMessage({ id: field.label })}
                            </label>
                            <div className="col-lg-9 col-xl-6">
                              {createFields(field, setFieldValue, values)}
                            </div>
                          </div>
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="3">
                        {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.CARD" })}
                      </Accordion.Toggle>
                    </Card.Header>

                    <Accordion.Collapse eventKey="3">
                      <Card.Body>
                        {formFields.filter(q => q.rowIdx <= 15 && q.rowIdx >= 11).map((field) => (
                          <div key={field.rowIdx} className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">
                              {intl.formatMessage({ id: field.label })}
                            </label>
                            <div className="col-lg-9 col-xl-6">
                              {createFields(field, setFieldValue, values)}
                            </div>
                          </div>
                        ))}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>

                </Accordion>
 */}


                {/* {formFields.map((field) => (
                  <div key={field.rowIdx} className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">
                      {intl.formatMessage({ id: field.label })}
                    </label>
                    <div className="col-lg-9 col-xl-6">
                      {createFields(field, setFieldValue, values)}
                    </div>
                  </div>
                ))} */}

                <button
                  type="submit"
                  style={{ display: "none" }}
                  ref={btnRef}
                  onSubmit={() => handleSubmit()}
                ></button>
              </div>
            </div>
          </Form>

        )}
      </Formik>
    </>

  );
};
